import { useEffect, useState } from "react";
import { createPayment, getTariffs } from "../components/api";
import { $userData } from "../store/userData";
import { setNotificationMessage, setShowNotification } from "../store";
import { useUnit } from "effector-react";
import "../styles/payment.scss";
import { isMobile } from "react-device-detect";


export const Payment = () => {
    const [tariffs, setTariffs] = useState([]);
    const userData = useUnit($userData);
    const [selectedTariff, setSelectedTariff] = useState(null);

    const canPay = userData.status === 4 || userData.status === 6 || userData.status === 2 || userData.status === 3 || userData.status === 7;

    useEffect(() => {
        getTariffs().then(data => { setTariffs(data) });
    }, []);

    const clickPay = () => {
        if(!selectedTariff){
            setNotificationMessage("Выберите тариф!");
            setShowNotification(true);
            return;
        }
        createPayment({ tariffId: selectedTariff, userId: userData.id })
            .then(data => {
                window.open(data, '_blank');
            })
            .catch(error => {
                const errorMessageData = error?.response?.data?.message;
                setNotificationMessage(errorMessageData
                    ? errorMessageData
                    : "Произошла непредвиденная ошибка");
                setShowNotification(true);
            });
    }

    return (
        <div className="payment">
            <div className="payment__card">
                {!isMobile && <h1 className="payment__title">Подписки</h1> }
                <p className="payment__subtitle">Оплата подписки{isMobile && <br />} за участие в торгах</p>
                <div className="payment__list">
                    {tariffs.map((tariff) => (
                        <label key={tariff.id}
                            className={`payment__item ${selectedTariff === tariff.id ? 'active' : ''}`}
                            onClick={() => setSelectedTariff(tariff.id)}>
                            <div className="payment__info">
                                <span className={`payment__radio-button ${selectedTariff === tariff.id ? 'checked' : ''}`}></span>
                                <span className="payment__name">{tariff.name}</span>
                            </div>
                            <span className="payment__price">{tariff.price} ₽</span>
                        </label>
                    ))}
                </div>
                <button disabled = {!canPay} variant="contained" className="payment__submit-button" onClick={clickPay}>
                    Оплатить
                </button>
            </div>
        </div>
    );
};
